import { Operation } from "rfc6902/diff";
import {
	CreateBlueprintInfo,
	createBlueprint,
	getBlueprintContent,
	updateBlueprintContent
} from "../base/BlueprintService";
import { DashboardBlueprint } from "./DashboardTypes";

const DASHBOARD_BLUEPRINT_SUFFIX = "dashboards";

export function createDashbardBlueprint(
	info: CreateBlueprintInfo
): Promise<string> {
	return createBlueprint(DASHBOARD_BLUEPRINT_SUFFIX, info);
}

export function getDashboardBlueprintContent(
	id: number
): Promise<DashboardBlueprint> {
	return getBlueprintContent<DashboardBlueprint>(
		DASHBOARD_BLUEPRINT_SUFFIX,
		id
	);
}

export function updateDashboardBlueprintContent(
	id: number,
	content: Operation[]
): Promise<void> {
	return updateBlueprintContent(DASHBOARD_BLUEPRINT_SUFFIX, id, content);
}
